// extracted by mini-css-extract-plugin
export default {"root":"moneyBackGuarantee_root__a891h"};